// v2 TV display config — which fields the queue board shows per patient.
//
// These values come from the TV profile the staff picked (see ./profiles),
// which is configured in the dashboard under Settings -> TV Configuration.
// This module now only owns the shape and the defaults; nothing here fetches.
//
// Gone on purpose: the legacy per-hospital endpoint
// (GET /tv-configuration/:hospitalId) and the "profileTVSettings" localStorage
// override. That override took precedence over the server config, so a stale
// toggle left on one TV silently beat whatever the dashboard said — exactly
// the confusion profiles exist to remove.

export interface TVDisplayConfig {
  token: boolean;
  patient_name: boolean;
  room_number: boolean;
  slot: boolean;
  booking_mode: boolean;
  // Not a per-patient field like the others — this caps how MANY patients the
  // board renders. It rides along here because the profile already reaches the
  // queue panel through this context, so no extra plumbing is needed.
  // null = show every patient, which is how the board behaved before this existed.
  patient_display_limit: number | null;
}

export const DEFAULT_TV_CONFIG: TVDisplayConfig = {
  token: true,
  patient_name: true,
  room_number: false,
  slot: true,
  booking_mode: true,
  patient_display_limit: null,
};

// The API returns real booleans, but these fields have been through enough
// shapes (0/1, "true") that coercing is cheaper than trusting.
export const toBool = (v: any, dflt: boolean): boolean => {
  if (v == null) return dflt;
  if (typeof v === "boolean") return v;
  if (typeof v === "number") return v !== 0;
  if (typeof v === "string") return v === "1" || v.toLowerCase() === "true";
  return dflt;
};

// null/absent/0/unparseable all mean "no limit" — the board shows everyone.
export const toLimit = (v: any): number | null => {
  if (v == null) return null;
  const n = typeof v === "number" ? v : parseInt(String(v), 10);
  return Number.isFinite(n) && n > 0 ? n : null;
};
